import { RenderItemProps, VirtualList } from '@shared/components/ui/VirtualList';
import { useTranslation } from 'react-i18next';
import { PrintersModel } from '../../models/Printers';
import { Card } from './Card';

interface CardListProps {
  printers: PrintersModel[];
  isLoading?: boolean;
  className?: string;
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  sorting?: any;
  onSortingChange?: (sorting: any) => void;
  total?: number;
  showActions?: boolean;
  estimateItemHeight?: number;

  // ✅ Necesario para habilitar edición
  onEdit?: (printer: PrintersModel) => void;
}

export const CardList = ({
  printers,
  fetchNextPage,
  hasNextPage = false,
  isFetchingNextPage = false,
  sorting,
  onSortingChange,
  total,
  className = '',
  showActions = true,
  estimateItemHeight = 120,
  onEdit = () => {}, // ✅ fallback
}: CardListProps) => {
  const { t } = useTranslation('printersModule');

  // ✅ Le pasamos onEdit al Card
  const renderLocationCard = (props: RenderItemProps<PrintersModel>) => (
    <Card {...props} onEdit={onEdit} showActions={showActions} />
  );

  const getPrintersKey = (printer: PrintersModel) => printer.id;

  return (
    <VirtualList
      data={printers}
      renderItem={renderLocationCard}
      itemKey={getPrintersKey}
      estimateItemHeight={estimateItemHeight}
      height="calc(100vh - 280px)"
      gap={0}
      emptyMessage={t('empty.message')}
      className={`rounded-lg shadow-sm ${className}`}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      infiniteScrollThreshold={100}
      sorting={sorting}
      onSortingChange={onSortingChange}
      total={total}
      listClassName="touch-pan-y"
      itemClassName="touch-manipulation"
    />
  );
};
